import React from 'react';
import styles from './AttributeLine.module.scss';
import { LabeledDropdown, CheckBox, Button, Input, LightTableLineContainer } from 'components';
import { colorOptions, clothesSizeOptions, shoesUsSizeOptions } from './attribute-options';

const AttributeLine = props => {
  const {
    attribute,
    setAttribute,
    deleteLine
  } = props;

  const attributeOptions = {
    placeholder: '',
    values: []
  };

  switch (attribute.type) {
    case 'Color': {
      attributeOptions.placeholder = 'Select color(s)';
      attributeOptions.values = colorOptions;
      break;
    }
    case 'Size: Clothing': {
      attributeOptions.placeholder = 'Select cloths sizes';
      attributeOptions.values = clothesSizeOptions;
      break;
    }
    case 'size: shoes (US)': {
      attributeOptions.placeholder = 'Select shoes sizes';
      attributeOptions.values = shoesUsSizeOptions;
      break;
    }
    default: break;
  }

  return (
    <LightTableLineContainer>
      <LabeledDropdown
        size='small'
        options={['Color', 'Size: Clothing', 'size: shoes (US)']}
        selectedOptions={[attribute.type]}
        onSelect={([value]) => setAttribute({ ...attribute, type: value, values: [], opt: false })}
        placeholder='Select attribute'
      />

      {attribute.type &&
        <>
          <Input
            size='small'
            className={styles.attributeNameInput}
            value={attribute.name}
            placeholder='Type the attribute name'
            onChange={name => setAttribute({ ...attribute, name })}
          />
          <LabeledDropdown
            key={attributeOptions.placeholder}
            size='small'
            maxSelections={attributeOptions.values.length}
            options={attributeOptions.values}
            selectedOptions={attribute.values}
            placeholder={attributeOptions.placeholder}
            onSelect={selectedValues => setAttribute({ ...attribute, values: selectedValues })}
          />
        </>
      }

      {!!attribute.values.length &&
        <CheckBox
          label='optional'
          checked={attribute.opt}
          onClick={() => setAttribute({ ...attribute, opt: !attribute.opt })}
        />
      }

      <Button
        type='cancel'
        size='small'
        className={styles.deleteBttn}
        onClick={deleteLine}
      >
        delete
    </Button>

    </LightTableLineContainer>
  );
};

export default AttributeLine;
